import { FaceBookIcon, LinkedInIcon, TwitterXIcon } from '../../icons'
import { permissionsHandler } from '../../../functions'
import { useSelector } from 'react-redux'
import cookies from 'react-cookies'
import React, { useEffect, useMemo } from 'react'
import { message } from 'antd'
import { Link, navigate } from 'gatsby'
import { auth0Roles } from '../../../config'
import FooterNavigationLinks from './FooterNavigationLinks'
import useGMT from '../../../hooks/useGTM'
import { HUBSPOT_INTEGRATION } from '../../../data'

const Footer = ({
  globalData,
  hideCTA,
  openLoginModal,
  // openSignupModal,
  userRole,
  location
}) => {
  const { pushSubscribeToNewsletterEvent } = useGMT()

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/embed/v2.js'
    document.body.appendChild(script)

    script.addEventListener('load', () => {
      if (window.hbspt) {
        loadSubscribeForm()
      }
    })
  }, [])

  function loadSubscribeForm() {
    document.getElementById('hubspotForm').innerHTML = ''

    window.hbspt.forms.create({
      region: 'na1',
      portalId: HUBSPOT_INTEGRATION.PORTAL_ID,
      formId: HUBSPOT_INTEGRATION.NEWSLETTER_FORM_ID,
      target: '#hubspotForm',
      onFormSubmitted: function () {
        message.success('Thanks for subscribing!')
        pushSubscribeToNewsletterEvent()
        loadSubscribeForm()
      },
    })
  }

  const navigateJoinNow = () => {
    navigate('/join-now')
  }

  let user = cookies.load('user')
  const storeProducts = useSelector(state => state.user).products
  let products = permissionsHandler(storeProducts, user?.role?.id)

  const isJoinNow = useMemo(() => {
    if(location?.pathname?.includes("join-now")) {
      return true;
    } else {
      return false;
    }
  }, [location?.pathname])

  return (
    <div className="footer-wrapper relative relative font-sans">
      <div className="container mx-auto">
        {hideCTA && user ? (
          <div />
        ) : (
          !hideCTA &&
          !user && (
            <div className="bg-voyage w-4/5 mx-auto py-7 flex flex-wrap sm:p-24 items-center justify-between mb-8 lg:-mb-32 relative">
              <div className="w-full text-center lg:w-1/2 md:text-left px-4">
                <h1 className="text-white m-0 sm:mb-3 font-playfair text-headingThree font-normal">
                  Become a MedReps member
                </h1>
                <p className="text-lightText font-sans text-sm md:text-base mb-0">
                  Become a MedReps member for unlimited access to medical sales
                  jobs, career advice and salary information. Kickstart your
                  career in medical sales today.
                </p>
              </div>
              <button
                className="mx-auto md:ml-3 mt-10 mb-3 lg:mt-0 sm:mb-0 lg:ml-0 sm:mr-0 bg-alabaster py-4 px-16 rounded text-white bg-button text-xl"
                onClick={() => navigateJoinNow()}
              >
                Join Now!
              </button>
            </div>
          )
        )}
      </div>
      <div className={isJoinNow? "footer-main w-full bg-footerBg pt-12 lg:pt-12": "footer-main w-full bg-footerBg pt-12 lg:pt-48"}>
        <div className="container mx-auto pb-24 border-b px-[30px] border-black/[.2]">
          <div className="flex flex-wrap pt-8 justify-between items-center">
            <div className="basis-full sm:basis-1/3">
              <div className="w-full mb-5">
                <div className="flex flex-col">
                  <h1 className="font-playfair text-[26px] lg:text-2xl font-normal mb-2">
                    Subscribe To Our Newsletter
                  </h1>

                  <p className="font-normal font-sans text-base py-2">
                    By subscribing to our mailing list, you agree to receive
                    marketing communications, updates, and relevant information
                    about our services and offers. We are committed to
                    respecting your preferences, and you can unsubscribe from
                    these communications at any time by following the link
                    provided in our emails or contacting our support team. Your
                    privacy is important to us, and we ensure that your
                    information is safe and handled in accordance with{' '}
                    <a href="/privacy-policy" target="_blank">
                      MedReps' privacy policy
                    </a>
                    .
                  </p>
                  <div id="hubspotForm"></div>
                </div>
              </div>

              <a href="/" className="cursor-pointer">
                <img
                  src="/images/logo.png"
                  className="w-40 mb-0"
                  alt="Medreps Logo"
                />
              </a>

              <div className="flex mt-8 items-center">
                {globalData?.footer?.socialMedia?.map((social, index) => {
                  return (
                    <a
                      target="_blank"
                      key={index}
                      href={social?.url}
                      className="text-footerIcon hover:text-charcoal mr-5"
                    >
                      {social?.url.indexOf('facebook') !== -1 ? (
                        <FaceBookIcon />
                      ) : social?.url.indexOf('twitter') !== -1 ? (
                        <TwitterXIcon />
                      ) : social?.url.indexOf('linkedin') !== -1 ? (
                        <LinkedInIcon />
                      ) : (
                        <div />
                      )}
                    </a>
                  )
                })}
              </div>
            </div>
            <div className="w-full sm:w-3/5 flex flex-wrap justify-between pt-7 lg:pt-0">
              <FooterNavigationLinks title="MEMBERS">
                <ul className="ml-0">
                  {!user && (
                    <li className="mb-2">
                      <span
                        className="text-base text-black cursor-pointer"
                        onClick={() => {
                          openLoginModal()
                        }}
                      >
                        Login
                      </span>
                    </li>
                  )}
                  {!user ? (
                    <li className="mb-2" onClick={() => navigateJoinNow()}>
                      <span className="text-base text-black cursor-pointer">
                        Membership
                      </span>
                    </li>
                  ) : (
                    userRole === auth0Roles.Member.id &&
                    !products?.subscriptionPurchased && (
                      <li className="mb-2">
                        <Link
                          to="/member-subscription/subscription/"
                          className="text-base text-black"
                        >
                          Membership
                        </Link>
                      </li>
                    )
                  )}

                  <li className="mb-2">
                    <Link to="/job-search/" className="text-base text-black">
                      Search Jobs
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link
                      to="/medical-sales-careers/"
                      className="text-base text-black"
                    >
                      Career Advice
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/salary/" className="text-base text-black">
                      Medical Sales Salaries
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/faq-candidate" className="text-base text-black">
                      FAQ
                    </Link>
                  </li>
                </ul>
              </FooterNavigationLinks>
              <FooterNavigationLinks title="JOB POSTERS">
                <ul className="ml-0">
                  {!user && (
                    <li className="mb-2">
                      <span
                        className="text-base text-black cursor-pointer"
                        onClick={() => {
                          openLoginModal()
                        }}
                      >
                        Login
                      </span>
                    </li>
                  )}
                  {!user ? (
                    <li className="mb-2">
                      <Link
                        to={'/employer/signup/'}
                        className="text-base text-black"
                      >
                        Buy Jobs
                      </Link>
                    </li>
                  ) : (
                    userRole !== auth0Roles.Member.id &&
                    !products?.subscriptionPurchased && (
                      <li className="mb-2">
                        <Link
                          to={'/employer/membership/'}
                          className="text-base text-black"
                        >
                          Buy Jobs
                        </Link>
                      </li>
                    )
                  )}
                  <li className="mb-2">
                    <Link to="/faq-employer" className="text-base text-black">
                      FAQ
                    </Link>
                  </li>
                </ul>
              </FooterNavigationLinks>
              <FooterNavigationLinks title="ABOUT">
                <ul className="ml-0">
                  <li className="mb-2">
                    <Link to="/about" className="text-base text-black">
                      About MedReps
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link
                      to="/manage-email-preference"
                      className="text-base text-black"
                    >
                      Manage Email Preferences
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/contact" className="text-base text-black">
                      Contact Us
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link to="/privacy-policy" className="text-base text-black">
                      Privacy Policy
                    </Link>
                  </li>
                  <li className="mb-2">
                    <Link
                      href="/privacy-policy"
                      className="text-base text-black"
                    >
                      Terms of Use
                    </Link>
                  </li>
                </ul>
              </FooterNavigationLinks>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center md:justify-between items-center container mx-auto py-8">
          <p className="text-sm text-center text-black sm:text-left font-sans mb-0 basis-full sm:basis-1/2 mb-4">
            {globalData?.footer?.smallText}
          </p>
        </div>
      </div>
    </div>
  )
}
export default Footer
